export class BookingTotalKms {
    constructor(public isBookingVerified: boolean, public farePriceKMS: number,
        public balanceBeforePayment: number, public balanceAfterPayment: number, public isLogout: boolean) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/booking-total.model.ts